export const carryCap = [
  { str: 1, light: 3, med: 6, heavy: 10 },
  { str: 2, light: 6, med: 13, heavy: 20 },
  { str: 3, light: 10, med: 20, heavy: 30 },
  { str: 4, light: 13, med: 26, heavy: 40 },
  { str: 5, light: 16, med: 33, heavy: 50 },
  { str: 6, light: 20, med: 40, heavy: 60 },
  { str: 7, light: 23, med: 46, heavy: 70 },
  { str: 8, light: 26, med: 53, heavy: 80 },
  { str: 9, light: 30, med: 60, heavy: 90 },
  { str: 10, light: 33, med: 66, heavy: 100 },
  { str: 11, light: 38, med: 76, heavy: 115 },
  { str: 12, light: 43, med: 86, heavy: 130 },
  { str: 13, light: 50, med: 100, heavy: 150 },
  { str: 14, light: 58, med: 116, heavy: 175 },
  { str: 15, light: 66, med: 133, heavy: 200 },
  { str: 16, light: 76, med: 153, heavy: 230 },
  { str: 17, light: 86, med: 173, heavy: 260 },
  { str: 18, light: 100, med: 200, heavy: 300 },
  { str: 19, light: 116, med: 233, heavy: 350 },
  { str: 20, light: 133, med: 266, heavy: 400 },
  { str: 21, light: 153, med: 306, heavy: 460 },
  { str: 22, light: 173, med: 346, heavy: 520 },
  { str: 23, light: 200, med: 400, heavy: 600 },
  { str: 24, light: 233, med: 466, heavy: 700 },
  { str: 25, light: 266, med: 533, heavy: 800 },
  { str: 26, light: 306, med: 613, heavy: 920 },
  { str: 27, light: 346, med: 693, heavy: 1040 },
  { str: 28, light: 400, med: 800, heavy: 1200 },
  { str: 29, light: 466, med: 933, heavy: 1400 },
];
